/**
 * @generated SignedSource<<0a011f299179ee7b02820ce7966fdf62>>
 * @relayHash 2b91a1d1ce37002b52ce23ae480906df
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 2b91a1d1ce37002b52ce23ae480906df

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "envVar"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "envVar",
        "variableName": "envVar"
      }
    ],
    "kind": "ScalarField",
    "name": "env",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QEnvQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QEnvQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "2b91a1d1ce37002b52ce23ae480906df",
    "metadata": {},
    "name": "QEnvQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "d7ea432ebad861a66b32148064e21db4";

export default node;
